/**
 * Convert radians to degrees.
 *
 * @param {number} radians The amount of radians to convert.
 * @return {number}
 */
function radians_to_degrees( radians ) {

	return radians * ( 180 / Math.PI );

}


/**
 * Convert degrees to radians.
 *
 * @param {number} degrees The amount of degrees to convert.
 * @return {number}
 */
function degrees_to_radians( degrees ) {

	return degrees * ( Math.PI / 180 );

}
